// extracted by mini-css-extract-plugin
module.exports = {"shopIcon":"ShopIcon_shopIcon__1aWaB","iconContainer":"ShopIcon_iconContainer__17JbI","icon":"ShopIcon_icon__3V4zS","shopName":"ShopIcon_shopName__2unSO"};